/** @jsx jsx */

import { clients } from "utils/clients";
import { jsx, Variable, StringScalar, render, Mutation, SelectionSet, Field, IdScalar } from "graphql-jsx";
import { UuidScalar } from "GraphQL/Scalars";

type Option = Readonly<{
  id: string;
  type: string;
  value: string;
  languageCode: string;
}>;

export const UpdateDescAlbum = async (option: Option) => {
  const $id = <Variable name="id" scalar={<UuidScalar />} value={option.id} />;
  const $type = <Variable name="type" scalar={<StringScalar />} value={option.type} />;
  const $value = <Variable name="value" scalar={<StringScalar />} value={option.value} />;
  const $languageCode = <Variable name="language_code" scalar={<IdScalar />} value={option.languageCode} />;
  const { query, variables } = render(
    <Mutation operationName="UPDATE_DESC_ALBUM">
      <SelectionSet
        name="updateMetadata_title"
        alias="updateDescAlbum"
        argument={{
          where: {
            id: $id
          },
          data: {
            type_metadata_title: $type,
            value: $value,
            language: {
              connect: {
                language_code: $languageCode
              }
            }
          }
        }}
      >
        <Field name="id" />
        <Field name="value" />
      </SelectionSet>
    </Mutation>
  );

  type Data = Readonly<{
    updateDescAlbum: {
      id: string;
      value: string;
    };
  }>;

  return await clients.metadata.request<Data>(query, variables);
};
